import DataDisplayRowI from "../DataDisplayRowI";
import getKPIObjectiveRow from "../DataDisplayRow/KPIObjectiveRow";
import DataDisplayTable from "../DataDisplayTable";

class KPIObjectiveTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getKPIObjectiveRow()
    }
}

let kpiObjectiveTableTable: KPIObjectiveTable | null = null;

export default function getKPIObjectiveTable(): KPIObjectiveTable {
    if (kpiObjectiveTableTable === null)
        kpiObjectiveTableTable = new KPIObjectiveTable()
    return kpiObjectiveTableTable
}